import { aspenApi as api, moneyMarketProductsList } from "@aspen/services";
import { generateDataCacheKey } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import { type IReqMoneyMarketProducts } from "@aspen/model";

/**
 * 获取moneyMarket产品列表。
 * @param {IReqMoneyMarketProducts} params - 获取moneyMarket产品列表所需的参数。
 */
export const useFetchMoneyMarketProducts = (params: IReqMoneyMarketProducts) => {
  const apiPath = api.savings.moneyMarket.productList;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const { error, data, isLoading, refetch } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    queryFn: () => {
      return moneyMarketProductsList(params).then(res => {
        if (res?.code == "0") {
          return res.data;
        }
      });
    },
    retry: 3,
  });
  return { error, data, refetch, queryKey, isLoading };
};
